module.exports = __webpack_public_path__ + "8ecf62aa455696b4b4332c1c2d3c2546.pdf";